import { useState } from 'react';
import { ButtonReset, Stack } from '@koob/margaret';
import { KoobButton } from '@koob/ui';
import { useFormikContext } from 'formik';
import { useDeepCompareEffect } from 'react-use';

const TogglableField = ({ idleElement, activeElement, disabled }) => {
  const [isToggled, setIsToggled] = useState(false);
  const { initialValues } = useFormikContext();
  const handleKeyPress = (event) => {
    if (event.charCode === 13) {
      setIsToggled(false);
      event.preventDefault();
    }
  };

  useDeepCompareEffect(() => {
    if (isToggled) {
      setIsToggled(false);
    }
  }, [{ initialValues }]);

  if (isToggled) {
    return (
      <Stack
        direction="column"
        size="full"
        gutterSize={0.5}
        onKeyPress={handleKeyPress}
      >
        {activeElement}
        <Stack size="full" alignX="flex-end">
          <KoobButton onClick={() => setIsToggled(false)} variant="primary">
            OK
          </KoobButton>
        </Stack>
      </Stack>
    );
  }

  return (
    <Stack gutterSize={0.5}>
      <ButtonReset
        disabled={disabled}
        type="button"
        onClick={() => setIsToggled(true)}
        style={{ flex: 1 }}
      >
        {idleElement}
      </ButtonReset>
    </Stack>
  );
};

export default TogglableField;
